import { Client, Account, Databases, Storage} from 'appwrite';

export const client = new Client();

const PROJECT_ID = process.env.REACT_APP_APPWRITE_PROJECT_ID;
const ENDPOINT = process.env.REACT_APP_APPWRITE_ENDPOINT;

client
    .setEndpoint(ENDPOINT)
    .setProject(PROJECT_ID); // Replace with your project ID

export const account = new Account(client);
export { ID } from 'appwrite';

export const database = new Databases(client);

export const storage = new Storage(client);